import { HeartHandshake } from "lucide-react";
import { Reveal } from "./shared";

export const SocialImpact = () => (
  <section className="px-4 pb-24 sm:px-6 lg:px-8" data-testid="social-impact-section">
    <Reveal className="mx-auto max-w-7xl">
      <div className="relative overflow-hidden rounded-3xl bg-[#1E7B4F] px-8 py-16 shadow-xl sm:px-16 sm:py-20">
        <div className="absolute -top-16 -right-16 h-64 w-64 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-16 -left-16 h-64 w-64 rounded-full bg-[#F97316]/20 blur-3xl" />
        <div className="relative mx-auto max-w-3xl text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-white/15">
            <HeartHandshake className="h-7 w-7 text-[#F97316]" />
          </div>
          <p className="mt-6 text-sm font-semibold uppercase tracking-widest text-[#FBD9C0]">
            Beyond the workplace
          </p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            A skill they take home <span className="text-[#F97316]">for life</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-white/85">
            There's a wider social-impact benefit too: you're giving employees a potentially
            life-saving skill that they take with them for life — into their homes, families and
            communities.
          </p>
          <p className="mt-4 text-base text-white/70">
            A genuine wellbeing benefit your people remember — and a tangible social-impact story
            for your ESG and CSR reporting.
          </p>
        </div>
      </div>
    </Reveal>
  </section>
);
